/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  TextField,
  MenuItem,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  CircularProgress,
  Chip
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import RefreshIcon from "@material-ui/icons/Refresh";
import PlaylistAddCheckIcon from "@material-ui/icons/PlaylistAddCheck";
import FlashOnIcon from "@material-ui/icons/FlashOn";
import { SalaryService } from "_services/salary.service";

const useStyles = makeStyles(theme => ({
  cardHeader: {
    backgroundColor: "#f5f5f5",
    padding: "12px 16px",
    borderBottom: "1px solid #e0e0e0"
  },
  tableHeader: {
    backgroundColor: "#eceff1",
    fontWeight: "bold"
  },
  tableRow: {
    "&:nth-of-type(even)": {
      backgroundColor: "#fafafa"
    },
    "&:hover": {
      backgroundColor: "#f0f4f8"
    }
  },
  sumBox: {
    backgroundColor: "#e8f5e9",
    border: "1px solid #81c784",
    borderRadius: 8,
    padding: theme.spacing(2),
    textAlign: "right"
  }
}));

export default function SalaryBatchCategoryManager({
  calYear,
  calMonth,
  incomes = [],
  outcomes = [],
  typeGovList = []
}) {
  const classes = useStyles();
  const [localTypeGovList, setLocalTypeGovList] = useState([]);
  const [typeInOut, setTypeInOut] = useState("in");
  const [selectedItemId, setSelectedItemId] = useState("");
  const [typeGov, setTypeGov] = useState(0);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [categoryData, setCategoryData] = useState(null);
  const [items, setItems] = useState([]);
  const [bulkValue, setBulkValue] = useState("");

  const activeTypeGovList = typeGovList && typeGovList.length > 0 ? typeGovList : localTypeGovList;

  // If typeGovList is not passed, fetch from table typegov via API
  useEffect(() => {
    if (!typeGovList || typeGovList.length === 0) {
      SalaryService.getTypeGov()
        .then(res => {
          const raw = res.data?.data || (Array.isArray(res.data) ? res.data : []);
          if (Array.isArray(raw) && raw.length > 0) {
            setLocalTypeGovList(
              raw.map(t => ({
                key: t.typeGovKey || t.TypeGovKey || t.key,
                name: t.name || t.Name,
                code: t.code || t.Code
              }))
            );
          }
        })
        .catch(err => console.error("Error loading typeGov in CategoryManager:", err));
    }
  }, [typeGovList]);

  const currentItemList = typeInOut === "out" ? outcomes : incomes;

  // Set default selected item
  useEffect(() => {
    if (currentItemList.length > 0) {
      const exists = currentItemList.some(
        i => (i.incomeID || i.outcomeID) === selectedItemId
      );
      if (!exists) {
        setSelectedItemId(
          typeInOut === "out"
            ? currentItemList[0].outcomeID
            : currentItemList[0].incomeID
        );
      }
    }
  }, [typeInOut, currentItemList]);

  // Load items when parameters change
  useEffect(() => {
    if (calYear && calMonth && selectedItemId) {
      loadData();
    }
  }, [calYear, calMonth, typeInOut, selectedItemId, typeGov]);

  const loadData = async () => {
    if (!selectedItemId) return;
    setLoading(true);
    try {
      const res = await SalaryService.getCategoryItems(
        calYear,
        calMonth,
        typeInOut,
        selectedItemId,
        typeGov
      );
      if (res.data && res.data.success && res.data.data) {
        setCategoryData(res.data.data);
        setItems(res.data.data.items || []);
      }
    } catch (err) {
      console.error("Error loading category items:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleValueChange = (userName, val) => {
    const num = parseFloat(val) || 0;
    setItems(prev =>
      prev.map(item => (item.userName === userName ? { ...item, value: num } : item))
    );
  };

  const handleApplyBulk = () => {
    const num = parseFloat(bulkValue) || 0;
    if (
      window.confirm(
        `ต้องการกำหนดค่า ${num.toLocaleString()} บาท ให้กับบุคลากรทุกคนในรายการนี้หรือไม่?`
      )
    ) {
      setItems(prev => prev.map(item => ({ ...item, value: num })));
    }
  };

  const totalSum = items.reduce((sum, item) => sum + (item.value || 0), 0);

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload = {
        calYear,
        calMonth,
        typeInOut,
        itemID: selectedItemId,
        typeGov,
        items: items.map(i => ({
          userName: i.userName,
          value: i.value || 0
        }))
      };

      const res = await SalaryService.saveCategoryItems(payload);
      if (res.data && res.data.success) {
        alert("บันทึกข้อมูลตามหมวดเรียบร้อยแล้ว");
        loadData();
      } else {
        alert(res.data?.message || "เกิดข้อผิดพลาดในการบันทึก");
      }
    } catch (err) {
      console.error("Error saving category batch:", err);
      alert("เกิดข้อผิดพลาดในการบันทึกข้อมูล");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Card variant="outlined">
      <div className={classes.cardHeader}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="ประเภทรายการ"
              value={typeInOut}
              onChange={e => setTypeInOut(e.target.value)}
            >
              <MenuItem value="in">รายการได้ (Incomes)</MenuItem>
              <MenuItem value="out">รายการหัก (Deductions)</MenuItem>
            </TextField>
          </Grid>

          <Grid item xs={12} sm={4}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="เลือกหมวดรายการ"
              value={selectedItemId || ""}
              onChange={e => setSelectedItemId(Number(e.target.value))}
            >
              {currentItemList.map(item => (
                <MenuItem
                  key={item.incomeID || item.outcomeID}
                  value={item.incomeID || item.outcomeID}
                >
                  {item.incomeName || item.outcomeName}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={3}>
            <TextField
              select
              fullWidth
              size="small"
              variant="outlined"
              label="ประเภทบุคลากร"
              value={typeGov}
              onChange={e => setTypeGov(Number(e.target.value))}
            >
              <MenuItem value={0}>ทั้งหมด</MenuItem>
              {activeTypeGovList.map(t => (
                <MenuItem key={t.key} value={t.key}>
                  {t.name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid item xs={12} sm={2} style={{ textAlign: "right" }}>
            <Button
              variant="outlined"
              size="medium"
              startIcon={<RefreshIcon />}
              onClick={loadData}
              disabled={loading}
            >
              รีเฟรช
            </Button>
          </Grid>
        </Grid>
      </div>

      <CardContent>
        {/* Quick Bulk Tool */}
        <Box mb={2} p={1.5} bgcolor="#f0f7ff" borderRadius={4} border="1px solid #bbdefb">
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={6}>
              <Typography variant="body2" color="primary" style={{ fontWeight: "bold" }}>
                <FlashOnIcon style={{ verticalAlign: "middle", fontSize: 18 }} />
                เครื่องมือกำหนดค่ายกชุด (Quick Bulk Fill):
              </Typography>
              <Typography variant="caption" color="textSecondary">
                กรอกจำนวนเงินแล้วกดปุ่มเพื่อกำหนดให้กับทุกคนในตารางนี้พร้อมกัน
              </Typography>
            </Grid>
            <Grid item xs={8} sm={3}>
              <TextField
                size="small"
                variant="outlined"
                fullWidth
                type="number"
                placeholder="จำนวนเงิน (บาท)"
                value={bulkValue}
                onChange={e => setBulkValue(e.target.value)}
              />
            </Grid>
            <Grid item xs={4} sm={3}>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                fullWidth
                onClick={handleApplyBulk}
                disabled={!bulkValue}
              >
                กำหนดให้ทุกคน
              </Button>
            </Grid>
          </Grid>
        </Box>

        {loading ? (
          <Box py={6} textAlign="center">
            <CircularProgress />
            <Typography style={{ marginTop: 8 }}>กำลังโหลดรายชื่อพนักงาน...</Typography>
          </Box>
        ) : (
          <>
            <TableContainer component={Paper} variant="outlined" style={{ maxHeight: 520 }}>
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow>
                    <TableCell className={classes.tableHeader} width={60} align="center">
                      ลำดับ
                    </TableCell>
                    <TableCell className={classes.tableHeader}>ชื่อ - สกุล</TableCell>
                    <TableCell className={classes.tableHeader}>ตำแหน่ง</TableCell>
                    <TableCell className={classes.tableHeader}>กลุ่มบุคลากร</TableCell>
                    <TableCell className={classes.tableHeader}>ธนาคาร / เลขบัญชี</TableCell>
                    <TableCell className={classes.tableHeader} align="right" width={180}>
                      จำนวนเงิน (บาท)
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={6} align="center" style={{ padding: 32 }}>
                        ไม่พบข้อมูลพนักงาน
                      </TableCell>
                    </TableRow>
                  ) : (
                    items.map((row, idx) => (
                      <TableRow key={row.userName} className={classes.tableRow}>
                        <TableCell align="center">{idx + 1}</TableCell>
                        <TableCell style={{ fontWeight: "bold" }}>{row.fullName}</TableCell>
                        <TableCell>{row.positionName || "-"}</TableCell>
                        <TableCell>
                          <Chip label={row.typeGovName || "-"} size="small" variant="outlined" />
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption" display="block">
                            {row.bankName || "-"}
                          </Typography>
                          <Typography variant="caption" color="textSecondary">
                            {row.accountNo || "-"}
                          </Typography>
                        </TableCell>
                        <TableCell align="right">
                          <TextField
                            type="number"
                            size="small"
                            variant="outlined"
                            value={row.value || ""}
                            placeholder="0.00"
                            onChange={e => handleValueChange(row.userName, e.target.value)}
                            inputProps={{
                              min: 0,
                              step: "0.01",
                              style: { textAlign: "right", fontWeight: "bold" }
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Bottom Summary & Save Button */}
            <Box mt={3}>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    startIcon={saving ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                    onClick={handleSave}
                    disabled={saving || loading || items.length === 0}
                  >
                    {saving ? "กำลังบันทึก..." : "บันทึกข้อมูลทั้งหมด"}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <div className={classes.sumBox}>
                    <Typography variant="caption" color="textSecondary">
                      ยอดรวมทั้งสิ้นในหมวดนี้ ({categoryData?.itemName || ""})
                    </Typography>
                    <Typography variant="h5" style={{ color: "#2e7d32", fontWeight: "bold" }}>
                      {totalSum.toLocaleString("th-TH", { minimumFractionDigits: 2 })} บาท
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </>
        )}
      </CardContent>
    </Card>
  );
}

